import React from "react";
import ellipse from "./Ellipse.module.css";

const Ellipse = (props) => {
  return <div className={`${ellipse.ellipse} ${props.className}`}></div>;
};

export default Ellipse;
